import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { UserSessionService } from 'bna-angular-auth-client';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private router: Router,
    private userSession: UserSessionService
  ) {}

  canActivate(state: RouterStateSnapshot) {
    if (this.userSession.isAuthenticated()) {
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/sign-in'], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }
}
